import { getDiscountedEventLevelPrice } from "../eventPricing";

export function getEventLevels(event: any): any[] {
  return Array.isArray(event?.levels) ? event.levels : [];
}

export function buildInitialEventTicketCounts(
  levels: any[],
  isLevelSoldOut: any
) {
  if (!Array.isArray(levels)) {
    return [];
  }

  const firstAvailableIndex = levels.findIndex(
    (level) => !isLevelSoldOut(level)
  );

  return levels.map((level, index) => {
    if (isLevelSoldOut(level)) {
      return 0;
    }

    return index === firstAvailableIndex ? 1 : 0;
  });
}

export function calculateEventTicketTotal(
  levels: any[],
  counts: number[],
  promotionCode: any,
  useOfferDiscountFallback: boolean
): number {
  const total = getEventLevels({ levels }).reduce((sum, level, index) => {
    const price = level.levelid
      ? getDiscountedEventLevelPrice(
          { levelid: level.levelid, price: level.price },
          promotionCode,
          { useOfferDiscountFallback }
        )
      : Number(level.price) || 0;
    const count = counts[index] || 0;

    return sum + price * count;
  }, 0);

  return Math.ceil(total * 100) / 100;
}

export function calculateEventTicketTotalWithoutDiscount(
  levels: any[],
  counts: number[]
): number {
  return getEventLevels({ levels }).reduce((sum, level, index) => {
    const price = level?.price || 0;
    const count = counts[index] || 0;

    return sum + price * count;
  }, 0);
}

export function buildUpdatedEventLevels(levels: any[], counts: number[]) {
  return getEventLevels({ levels }).reduce((acc, level, index) => {
    if (counts[index] > 0) {
      acc.push({
        ...level,
        tickets_amount: counts[index],
      });
    }

    return acc;
  }, []);
}
